import { format } from 'date-fns';
import { formatDate } from '../utils/formatDate';

// Defining known format types allows to to avoid inconsistency.
// These are currently the only formats used.
type FormatType = 'MM/dd/yyyy' | 'MMM d, yyyy' | 'MM/dd/yyyy - hh:mm a';

export function formatFullDate(
	date: string,
	formatType: FormatType = 'MM/dd/yyyy',
	convertToTimeZone?: boolean,
) {
	const parsedDate = new Date(date);
	const formattedDate = convertToTimeZone
		? formatDate(parsedDate, formatType)
		: format(parsedDate, formatType);
	return formattedDate;
}
